import CareerBanner from './CareerBanner';
import CareerSection from './CareerSection';

function Career() {
  return (
    <div>
      <CareerBanner />
      <CareerSection />
    </div>
  );
}

export default Career;